// extracted by mini-css-extract-plugin
export default {"navigationDiv":"Navigation_mobile_navigationDiv__U0L46","dropdown":"Navigation_mobile_dropdown__ixBpd","navigationLink":"Navigation_mobile_navigationLink__OtwBS"};